import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, MessageCircle, MapPin } from "lucide-react";
import {
    BRAND_FULL, TAGLINE, ADDRESS, PHONE_DISPLAY, PHONE_TEL,
    waLink, WA_MESSAGES, DIRECTIONS_URL, INSTAGRAM_URL, FACEBOOK_URL,
} from "@/config/site";

const EXPLORE = [
    { label: "Gold", to: "/collections?collection=gold" },
    { label: "Diamond", to: "/collections?collection=diamond" },
    { label: "Bridal", to: "/collections?collection=bridal" },
    { label: "Rings", to: "/collections?category=rings" },
    { label: "Earrings", to: "/collections?category=earrings" },
    { label: "Necklaces", to: "/collections?category=necklaces" },
    { label: "Bangles", to: "/collections?category=bangles" },
    { label: "Bracelets", to: "/collections?category=bracelets" },
    { label: "Pendants", to: "/collections?category=pendants" },
    { label: "Men's Jewellery", to: "/collections?collection=mens" },
];

const DISCOVER = [
    { label: "Our Story", to: "/about" },
    { label: "Custom Jewellery", to: "/custom" },
    { label: "Jewellery Guide", to: "/guide" },
    { label: "FAQs", to: "/faq" },
    { label: "Wishlist", to: "/wishlist" },
    { label: "Contact", to: "/contact" },
];

const Footer = () => (
    <footer className="bg-[#070709] border-t border-gold/15 pt-16 sm:pt-24 pb-32 lg:pb-10" data-testid="site-footer">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-10 lg:gap-8">
                <div className="col-span-2 md:col-span-1">
                    <p className="font-serif text-2xl tracking-[0.15em] text-ivory">
                        BSK <span className="gold-text">JEWELLERS</span>
                    </p>
                    <p className="text-[10px] tracking-[0.3em] uppercase text-sand mt-1">{BRAND_FULL}</p>
                    <p className="text-sm text-sand leading-relaxed mt-5 max-w-xs">{TAGLINE}</p>
                </div>
                <div>
                    <p className="eyebrow mb-5 !text-[10px]">Explore</p>
                    <ul className="space-y-2.5">
                        {EXPLORE.map((l) => (
                            <li key={l.label}>
                                <Link to={l.to} data-testid={`footer-explore-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-sand hover:text-gold transition-colors">
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="eyebrow mb-5 !text-[10px]">Discover</p>
                    <ul className="space-y-2.5">
                        {DISCOVER.map((l) => (
                            <li key={l.label}>
                                <Link to={l.to} data-testid={`footer-discover-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-sand hover:text-gold transition-colors">
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="eyebrow mb-5 !text-[10px]">Visit</p>
                    <p className="text-sm text-sand leading-relaxed flex items-start gap-2">
                        <MapPin size={14} className="text-gold mt-1 shrink-0" /> {ADDRESS}
                    </p>
                    <div className="mt-4 space-y-2.5">
                        <a href={DIRECTIONS_URL} target="_blank" rel="noreferrer" data-testid="footer-directions" className="block text-sm text-sand hover:text-gold transition-colors">Get Directions →</a>
                        <a href={`tel:${PHONE_TEL}`} data-testid="footer-call" className="flex items-center gap-2 text-sm text-sand hover:text-gold transition-colors">
                            <Phone size={13} className="text-gold" /> {PHONE_DISPLAY}
                        </a>
                        <a href={waLink(WA_MESSAGES.general)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 text-sm text-sand hover:text-gold transition-colors">
                            <MessageCircle size={13} className="text-gold" /> WhatsApp Us
                        </a>
                    </div>
                    <p className="eyebrow mt-8 mb-4 !text-[10px]">Connect</p>
                    <div className="flex gap-4">
                        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="w-9 h-9 border border-gold/25 flex items-center justify-center text-sand hover:text-gold hover:border-gold/60 transition-colors">
                            <Instagram size={15} strokeWidth={1.5} />
                        </a>
                        <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="w-9 h-9 border border-gold/25 flex items-center justify-center text-sand hover:text-gold hover:border-gold/60 transition-colors">
                            <Facebook size={15} strokeWidth={1.5} />
                        </a>
                    </div>
                </div>
            </div>
            <div className="mt-14 pt-6 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                <p className="text-[11px] text-sand/70 tracking-wide">© {new Date().getFullYear()} BSK Jewellers · {BRAND_FULL} · Amritsar</p>
                <div className="flex gap-6 text-[11px] text-sand/70">
                    <span>Privacy Policy</span>
                    <span>Terms &amp; Conditions</span>
                    <span>Exchange Policy — ask in showroom</span>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
